import { IInvoiceRespSchema } from '@monetize/types/app';
import { usePrintInvoiceToHtmlForInvoiceShare } from '../../api/shareService';
import { HtmlIFrameContentRenderer } from '../Monetize/HtmlIFrameContentRenderer';

interface InvoiceHtmlPublicProps {
  invoice: IInvoiceRespSchema;
  tenantId?: string;
  invoiceSecretId?: string;
}

export const InvoiceHtmlPublic = ({
  invoice,
  tenantId,
  invoiceSecretId,
}: InvoiceHtmlPublicProps) => {
  const { data, isLoading, isRefetching, error, isPending } =
    usePrintInvoiceToHtmlForInvoiceShare(
      {
        invoiceSecretId: invoiceSecretId!,
        tenantId: tenantId!,
        lastModifiedTimestamp: invoice.modifyDate,
      },
      { enabled: !!invoiceSecretId && !!tenantId },
    );

  if (error) {
    // TODO: add error state
    return null;
  }

  return (
    <HtmlIFrameContentRenderer
      id="invoice-content"
      html={data}
      isLoading={isLoading}
      isReFetching={isPending || isRefetching}
    ></HtmlIFrameContentRenderer>
  );
};
